'use client';

import { usePathname } from 'next/navigation';
import { AnimatePresence } from 'framer-motion';
import OnboardingProgress from './OnboardingProgress';

export default function OnboardingShell({ children }) {
  const pathname = usePathname();

  return (
    <div className="flex min-h-screen flex-col bg-background">
      {/* Top bar with logo + progress */}
      <header className="sticky top-0 z-30 flex items-center justify-between border-b border-border/40 bg-background/80 px-6 py-4 backdrop-blur-md">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <img src="/images/logos/tivion-logo.svg" alt="" className="h-8 w-8" />
          <span className="text-lg font-semibold tracking-tight text-foreground">
            Tivion
          </span>
        </div>

        {/* Progress indicator */}
        <OnboardingProgress />

        {/* Spacer for symmetry */}
        <div className="w-[100px]" />
      </header>

      {/* Main content — wider for landscape (bento grid needs room) */}
      <main className="flex flex-1 flex-col items-center justify-center px-4 py-8 sm:px-6 lg:px-8">
        <div className={`w-full ${pathname?.includes('/landscape') || pathname?.includes('/focus') ? 'max-w-5xl' : 'max-w-2xl'}`}>
          <AnimatePresence mode="wait">
            <div key={pathname}>
              {children}
            </div>
          </AnimatePresence>
        </div>
      </main>
    </div>
  );
}
